import styled from 'styled-components';

export const StyledIcon = styled.div`
    display: flex;
    justify-content: space-evenly;
    height: 100%;
    align-items: center;
`;

export const TitleAndActionContainer = styled.div`
    display: flex;
    justify-content: space-between;
`;
